export const containerStyles = {
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const buttonsContainerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  marginTop: '12px',
};
